@if (!utilityService.isSemiFullScreen) {
  <app-navbar></app-navbar>
}
<div class="template-content">
  <div class="template-content__container">
    <router-outlet></router-outlet>
  </div>
</div>
@defer (on idle) {
  @if (!utilityService.isSemiFullScreen && utilityService.isFooterVisible) {
    <app-footer-section></app-footer-section>
  }
} @placeholder {
  <div class="footer-placeholder"></div>
}
<div class="msg-wrapper" [ngClass]="{ visible: toastService.messages.length }">
  <ng-template #messageInsert></ng-template>
</div>
@if (pageLoadAction(pageLoadService.pageTemplate$ | async)) {
  <div></div>
}
